import ReviewImage from "../assets/underReview.png";
const UnderReview = () => {
  return (
    <div className=" flex flex-col items-center">
      <div className="text-[100px] text-[#191919] font-medium -tracking-[7px] mt-[30px]">
        Under Review
      </div>
      <img src={ReviewImage} alt="under review image" />
    </div>
  );
};

export default UnderReview;
